import { Cart } from "@type/carts";
import { Category } from "@type/categories";
import { Product } from "@type/products";
import { createContext, useContext } from "react";

export interface AppContextInterface {
  add: (productUID: string) => void;
  remove: (productUID: string) => void;
  clear: (productUID?: string) => void;
  cart: Cart;
  products: Product[] | undefined;
  categories: Category[] | undefined;
  setActiveCategory: (category: string | undefined) => void;
  activeCategory: string | undefined;
  showPaymentModal: boolean;
  setShowPaymentModal: (show: boolean) => void;
  totalPrice: string;
}

export const AppContext = createContext<AppContextInterface | undefined>(
  undefined
);

export const useAppContext = () => {
  return useContext(AppContext) as AppContextInterface;
};
